//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapState, mapGetters } from 'vuex';
import {
  faCommentAltLines,
  faSignOut,
  faAngleDown,
  faMoon,
  faDownToBracket,
} from '@fortawesome/pro-light-svg-icons';
import {
  faMeContributor,
} from '@motionelements/assets/src/js/me-font/icons-channels2022';
import {
  faUser,
  faUserVneck,
  faBuildings,
} from '@motionelements/assets/src/js/me-font/icons-fa6';
import { isExContributor } from '@motionelements/core/src/services/account.service.js';
import formUrl from '@motionelements/core/src/helpers/form-url.js';

export default {
  name: 'user-nav-dropdown',
  components: {
    NavTheme: () => import('./NavTheme.vue'),
  },
  props: {
    variant: {
      type: String,
    },
    onShow: Function,
  },
  data() {
    return {
      faUser,
      faCommentAltLines,
      faSignOut,
      faUserVneck,
      faBuildings,
      faAngleDown,
      faMoon,
      faMeContributor,
      faDownToBracket,
      avatarUrlError: false,
    };
  },
  computed: {
    ...mapState({
      member: state => state.user.member,
      isContributor: state => state.user.isArtist,
      isReseller: state => state.user.isReseller,
      isOrganization: state => state.user.isOrganization,
    }),
    ...mapGetters({
      isMember: 'user/isMember',
      avatarUrl: 'user/getAvatarUrl',
      displayName: 'user/getDisplayName',
    }),
    organizationInfo() {
      return this.isMember ? this.member.organization : '';
    },
    showAvatar() {
      return !this.avatarUrlError && this.avatarUrl && !this.avatarUrl.includes('https%3A%2F%2Fstatic.motionelements.com%2Fimg%2Fmember%2F');
    },
  },
  methods: {
    formUrl,
    emitOnShow() {
      this.$emit('onShow');
    },
    onAvatarUrlError(event) {
      this.avatarUrlError = true;
      event.onerror = null;
    },
    isExContributor,
  },
};
